export default __webpack_public_path__ + "static/media/main-banner.b9fc5dc8.mp4";